import React, { useState } from 'react';
import {
	Birthday,
	Coorperate,
	Event,
	Myself,
	Object as Img_Object,
	Other,
	Pet,
	SomeoneElse,
	WeddingDate,
} from '../../assets';
import CustomToggler from '../CustomToggler';
import { Modal, ModalBody, Form, Row, Col, Spinner } from 'reactstrap';
import { updateMemoir } from '../../redux/actions/memoir.action';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { customAlert } from '../../redux/actions/alertActions';
import CustomDatePicker from '../CustomDatePicker';

function EditMemora(props) {
	const [categories, setCategories] = useState([
		{ name: 'Myself', image: Myself },
		{ name: 'Someone else', image: SomeoneElse },
		{ name: 'Pet', image: Pet },
		{ name: 'Birthday', image: Birthday },
		{ name: 'Anniversary', image: WeddingDate },
		{ name: 'Event', image: Event },
		{ name: 'Coorperate', image: Coorperate },
		{ name: 'Object', image: Img_Object },
		{ name: 'Other', image: Other },
	]);
	const [deathOpen, setDeathOpen] = useState(false);
	const [updateSeleCat, setUpdateSeleCat] = useState('');

	const { uid } = useSelector(state => state.auth);
	const { loading } = useSelector(state => state.memoir);
	const dispatch = useDispatch();
	const handleMemoirEditField = (name, value) => {
		let memoData = props.memoirData;
		memoData[name] = value;
		props.setMemoirData(memoData);
	};
	const toggleDeath = () => {
		setDeathOpen(!deathOpen);
	};

	const checkCat = () => {
		if (
			props.selectedCat == 'Myself' ||
			props.selectedCat == 'Someone else'
		) {
			return categories?.slice(0, 2);
		} else {
			return categories?.slice(2, 9);
		}
	};
	return (
		<>
			<Modal
				isOpen={props.isOpen.category}
				size='xl'
				centered
				className='custom-modal'
			>
				<ModalBody>
					<div className='d-flex'>
						<div
							className='ml-auto pointer'
							onClick={() => props.toggleModalEdit('category')}
						>
							<i className='fa fa-times'></i>
						</div>
					</div>
					<div className='modal-content-wrapper pt-0'>
						<h4 className='text-center mt-3 font-weight-bold'>
							Choose from the categories Below
						</h4>
						<Row className='justify-content-center'>
							<Col md='10' xl='8'>
								<div className='row'>
									{checkCat()?.map((category, idx) => (
										<div className='col-md-6 col-lg-4 col-xl-4 mt-5 text-center'>
											<div
												className={`category-card ${
													(props.selectedCat ===
														category.name &&
														updateSeleCat === '') ||
													updateSeleCat ===
														category.name
														? 'active'
														: ''
												}`}
												onClick={e =>
													setUpdateSeleCat(
														category.name
													)
												}
											>
												<div className='card-body text-center d-flex flex-column'>
													<img
														src={category.image}
														style={{
															height: 70,
															margin: '0 auto',
														}}
														alt=''
													/>
													<span className='mt-3'>
														{category.name}
													</span>
												</div>
											</div>
										</div>
									))}
								</div>
							</Col>
						</Row>
						<button
							className='btn btn-outline d-block mx-auto mt-3 position-relative'
							style={{ fontSize: 32, minHeight: 60 }}
							onClick={e => {
								e.preventDefault();
								let myProfileType = '';
								if (
									props.selectedCat !== '' &&
									updateSeleCat === ''
								) {
									if (
										props.selectedCat == 'Myself' ||
										props.selectedCat == 'Someone else'
									) {
										props.setProfileType('person');
										myProfileType = 'person';
									} else {
										props.setProfileType('else');
										myProfileType = 'else';
									}
									props.toggleModalEdit('createTimeline');
								} else if (updateSeleCat !== '') {
									if (
										updateSeleCat == 'Myself' ||
										updateSeleCat == 'Someone else'
									) {
										props.setProfileType('person');
										myProfileType = 'person';
									} else {
										props.setProfileType('else');
										myProfileType = 'else';
									}
									props.toggleModalEdit('createTimeline');
								}
								if (myProfileType == 'person') {
									props.setMemoirData({
										memoir_title: props.mem.memoir_title
											? props.mem.memoir_title
											: '',
										title: props.mem.title
											? props.mem.title
											: '',
										first_name: props.mem.first_name
											? props.mem.first_name
											: '',
										last_name: props.mem.last_name
											? props.mem.last_name
											: '',
										introduction: props.mem.introduction
											? props.mem.introduction
											: '',
										relationship: props.mem.relationship
											? props.mem.relationship
											: '',
										date_of_birth: props.mem.date_of_birth
											? props.mem.date_of_birth
											: '',
										date_of_death: props.mem.date_of_death
											? props.mem.date_of_death
											: '',
										home_town: props.mem.home_town
											? props.mem.home_town
											: '',
										isMemoirPublic: props.mem.isMemoirPublic
											? props.mem.isMemoirPublic
											: '',
										isHomeTownPublic: props.mem
											.isHomeTownPublic
											? props.mem.isHomeTownPublic
											: '',
										isDOBPublic: props.mem.isDOBPublic
											? props.mem.isDOBPublic
											: '',
										isHideFromSearchEngines: props.mem
											.isHideFromSearchEngines
											? props.mem.isHideFromSearchEngines
											: '',
										isIntroductionVisible: props.mem
											.isIntroductionVisible
											? props.mem.isIntroductionVisible
											: '',
									});
								} else {
									console.log(
										'in else',
										props.memoirData,
										props.mem.location
									);
									props.setMemoirData({
										else_category: '',
										end_date: props.mem.end_date
											? props.mem.end_date
											: '',
										introduction: props.mem.introduction
											? props.mem.introduction
											: '',
										location: props.mem.location
											? props.mem.location
											: '',
										memoir_title: props.mem.memoir_title
											? props.mem.memoir_title
											: '',
										start_date: props.mem.start_date
											? props.mem.start_date
											: '',
										isMemoirPublic: props.mem.isMemoirPublic
											? props.mem.isMemoirPublic
											: '',
										isHomeTownPublic: props.mem
											.isHomeTownPublic
											? props.mem.isHomeTownPublic
											: '',
										isDOBPublic: props.mem.isDOBPublic
											? props.mem.isDOBPublic
											: '',
										isHideFromSearchEngines: props.mem
											.isHideFromSearchEngines
											? props.mem.isHideFromSearchEngines
											: '',
										isIntroductionVisible: props.mem
											.isIntroductionVisible
											? props.mem.isIntroductionVisible
											: '',
									});
								}
							}}
						>
							Update a Memoir
						</button>
					</div>
				</ModalBody>
			</Modal>
			<Modal
				isOpen={props.isOpen.createTimeline}
				size='lg'
				centered
				className='custom-modal'
				toggle={() => props.toggleModalEdit('createTimeline')}
			>
				<ModalBody>
					<div className='d-flex'>
						<div
							className='ml-auto pointer'
							onClick={e =>
								props.toggleModalEdit('createTimeline')
							}
						>
							<i className='fa fa-times'></i>
						</div>
					</div>
					<Form
						onSubmit={async e => {
							e.preventDefault();
							let obj = { ...props.memoirData };
							if (
								props.selectedCat != '' &&
								updateSeleCat == ''
							) {
								obj['category'] = props.selectedCat;
							} else if (updateSeleCat !== '') {
								obj['category'] = updateSeleCat;
							}

							console.log('Data...', obj);

							if (props.profileType == 'person') {
								if (
									props.memoirData.memoir_title == '' ||
									props.memoirData.title == '' ||
									props.memoirData.first_name == '' ||
									props.memoirData.last_name == '' ||
									props.memoirData.introduction == '' ||
									props.memoirData.home_town == ''
									// ||
									// props.memoirData.relationship == ''
								) {
									dispatch(
										customAlert(
											true,
											'Please fill all fields'
										)
									);
									setTimeout(() => {
										dispatch(customAlert(false, ''));
									}, 1500);
									// toast.warning('Please fill all fields');
								} else {
									if (uid) {
										// console.log('obj', obj)
										await dispatch(
											updateMemoir(obj, props.mem.id)
										);
										props.toggleModalEdit('createTimeline');
									} else {
										dispatch(
											customAlert(
												true,
												'Undefined user id!'
											)
										);
										setTimeout(() => {
											dispatch(customAlert(false, ''));
										}, 1500);
										// toast.warning('Undefined user id!');
									}
								}
							} else {
								if (
									props.memoirData.memoir_title == '' ||
									props.memoirData.introduction == ''
									// ||
									// props.memoirData.home_town == ''
								) {
									dispatch(
										customAlert(
											true,
											'Please fill all fields'
										)
									);
									setTimeout(() => {
										dispatch(customAlert(false, ''));
									}, 1500);
									// toast.warning('Please fill all fields');
								} else if (props.memoirData.category == '') {
									dispatch(
										customAlert(
											true,
											'Please Choose Category '
										)
									);
									setTimeout(() => {
										dispatch(customAlert(false, ''));
									}, 1500);
								} else {
									if (uid) {
										await dispatch(
											updateMemoir(obj, props.mem.id)
										);
									
										props.toggleModalEdit('createTimeline');
									} else {
										dispatch(
											customAlert(
												true,
												'Undefined user id!'
											)
										);
										setTimeout(() => {
											dispatch(customAlert(false, ''));
										}, 1500);
										// toast.warning('Undefined user id!');
									}
								}
							}
						}}
					>
						<div className='modal-content-wrapper pt-0'>
							<h5 className='mt-3 font-weight-bold text-center'>
								update a Memoir
							</h5>
							<span className='d-block timeline-for mt-4'>
								<h6>What is the Memoir for?</h6>
								<div className='d-flex radio-group'>
									{props.profileType == 'person' ? (
										<div className='d-flex radio align-items-center'>
											<input
												type='radio'
												name='profileType'
												value={
													props.memoirData
														.memoir_title
												}
												onClick={async e => {
													await props.setProfileType(
														'person'
													);
													props.setSelectedCat(
														'person'
													);
													
												}}
												checked={
													props.profileType ==
													'person'
												}
												id='person'
											/>
											<label
												className='ml-2 mt-2'
												for='person'
											>
												A Person
											</label>
										</div>
									) : (
										<div className='ml-5 d-flex radio align-items-center'>
											<input
												type='radio'
												name='profileType'
												onClick={async e => {
													await props.setProfileType(
														'else'
													);
													props.setSelectedCat(
														'else'
													);
											
												}}
												checked={
													props.profileType == 'else'
												}
												id='else'
											/>
											<label
												className='ml-2 mt-2'
												for='else'
											>
												Something else
											</label>
										</div>
									)}
								</div>
							</span>
							<div
								className={`${
									props.profileType == 'person'
										? 'd-block'
										: 'd-none'
								}`}
							>
								<div className='row mt-3'>
									<div className='col'>
										<label className='m-0'>
											Memoir Title
										</label>
										<input
											type='text'
											className='form-control'
											defaultValue={
												props.memoirData.memoir_title
											}
											placeholder='Memoir Title'
											required={
												props.profileType == 'person'
											}
											onChange={e =>
												handleMemoirEditField(
													'memoir_title',
													e.target.value
												)
											}
										/>
									</div>
								</div>
								<div className='row mt-3'>
									<div className='col-md-2'>
										<label className='m-0'>Title</label>
										<input
											type='text'
											className='form-control'
											defaultValue={
												props.memoirData.title
											}
											placeholder='Mr'
											required={
												props.profileType == 'person'
											}
											// defaultValue={props.memoirData.title}
											onChange={e =>
												handleMemoirEditField(
													'title',
													e.target.value
												)
											}
										/>
									</div>

									<div className='col-md-5'>
										<label className='m-0'>
											First Name
										</label>
										<input
											type='text'
											defaultValue={
												props.memoirData.first_name
											}
											className='form-control'
											placeholder='First name'
											required={
												props.profileType == 'person'
											}
											// defaultValue={props.memoirData.first_name}
											onChange={e =>
												handleMemoirEditField(
													'first_name',
													e.target.value
												)
											}
										/>
									</div>
									<div className='col-md-5'>
										<label className='m-0'>Last Name</label>
										<input
											type='text'
											defaultValue={
												props.memoirData.last_name
											}
											className='form-control'
											placeholder='Last name'
											required={
												props.profileType == 'person'
											}
											onChange={e =>
												handleMemoirEditField(
													'last_name',
													e.target.value
												)
											}
										/>
									</div>
								</div>

								<label className='d-flex mt-3 m-0'>
									Add an introduction
								</label>
								<textarea
									className='form-control'
									defaultValue={props.memoirData.introduction}
									rows='4'
									placeholder='This Timeline was created to help collect our memories in a single place online'
									required={props.profileType == 'person'}
									onChange={e =>
										handleMemoirEditField(
											'introduction',
											e.target.value
										)
									}
								/>
								<h5 className='d-flex mt-5 mb-4'>
									What's your relationship to them?
								</h5>
								<select
									className='form-control'
									defaultValue={props.memoirData.relationship}
									onChange={e =>
										handleMemoirEditField(
											'relationship',
											e.target.value
										)
									}
								>
									<option disabled selected>
										Select (Optional)
									</option>
									<option value='parent'>Parent</option>
									<option value='child'>Child</option>
									<option value='spouse'>Spouse</option>
									<option value='sibling'>Sibling</option>
									<option value='friend'>Friend</option>
								</select>
								<div className='row mt-3'>
									<div className='col-md-6'>
										<label className='d-flex m-0'>
											Date of Birth (optional)
										</label>
										<CustomDatePicker
											id={'test'}
											value={
												props.memoirData.date_of_birth
											}
											max={moment()
												.toISOString()
												.substring(0, 10)}
											onChange={e =>
												handleMemoirEditField(
													'date_of_birth',
													e.target.value
												)
											}
											isRequired={false}
										/>
									</div>
									<div className='col-md-6 '>
										<label className='d-flex m-0'>
											Date of Death (optional)
										</label>
										<span
											className={`${
												!deathOpen
													? 'd-block'
													: 'd-none'
											} mt-3`}
										>
											- Present{' '}
											<i
												className='ml-2 fa fa-pencil pointer'
												onClick={toggleDeath}
											></i>
										</span>
										<span
											className={`${
												deathOpen ? 'd-flex' : 'd-none'
											}`}
										>
											<input
												type='date'
												// defaultValue={props.memoirData.date_of_birth}
												max={moment()
													.toISOString()
													.substring(0, 10)}
												onChange={e =>
													handleMemoirEditField(
														'date_of_death',
														e.target.value
													)
												}
												className='form-control'
											/>
											<i
												className='ml-2 fa fa-times text-danger pointer mt-3'
												onClick={toggleDeath}
											></i>
										</span>
									</div>
								</div>
								<label className='d-flex mt-3 m-0'>
									What's their hometown?
								</label>
								<Row>
									<Col md='8'>
										<input
											type='text'
											defaultValue={
												props.memoirData.home_town
											}
											className='form-control'
											placeholder='City'
											required={
												props.profileType == 'person'
											}
											onChange={e =>
												handleMemoirEditField(
													'home_town',
													e.target.value
												)
											}
										></input>
									</Col>
								</Row>
							</div>
							<div
								className={`${
									props.profileType == 'else'
										? 'd-block'
										: 'd-none'
								}`}
							>
								<div className='row mt-3'>
									<div className='col'>
										<label className='m-0'>
											Memoir Title
										</label>
										<input
											type='text'
											defaultValue={
												props.memoirData.memoir_title
											}
											className='form-control'
											placeholder='Memoir Title'
											required={
												props.profileType == 'else'
											}
											onChange={e =>
												handleMemoirEditField(
													'memoir_title',
													e.target.value
												)
											}
										/>
									</div>
								</div>
								<Row>
									<Col md='8'>
										<label className='d-flex mt-3'>
											Choose a Catrgory
										</label>
										<select
											defaultValue={
												updateSeleCat == ''
													? props.selectedCat
													: updateSeleCat
											}
											className='form-control'
											required={
												props.profileType == 'else'
											}
											onChange={e =>
												handleMemoirEditField(
													'else_category',
													e.target.value
												)
											}
										>
											{categories.map(cat => {
												return (
													<option value={cat.name}>
														{cat.name}
													</option>
												);
											})}
										</select>
									</Col>
								</Row>
								<label className='d-flex mt-3'>
									Add an introduction
								</label>
								<textarea
									defaultValue={props.memoirData.introduction}
									className='form-control'
									required={props.profileType == 'else'}
									rows='4'
									placeholder='This Timeline was created to help collect our memories in a single place online'
									onChange={e =>
										handleMemoirEditField(
											'introduction',
											e.target.value
										)
									}
								/>
								<div className='row mt-3'>
									<div className='col-md-8'>
										<label>Start date</label>
										<CustomDatePicker
											id={'test'}
											value={props.memoirData.start_date}
											max={moment()
												.toISOString()
												.substring(0, 10)}
											onChange={e =>
												handleMemoirEditField(
													'start_date',
													e.target.value
												)
											}
											// isRequired={
											// 	props.profileType == 'else'
											// }
										/>
									</div>
								</div>
								<div className='row mt-3'>
									<div className='col-md-8'>
										<label>End date</label>
										<CustomDatePicker
											id={'test'}
											value={props.memoirData.end_date}
											max={moment()
												.toISOString()
												.substring(0, 10)}
											onChange={e =>
												handleMemoirEditField(
													'end_date',
													e.target.value
												)
											}
											isRequired={false}
										/>
									</div>
								</div>
								<Row>
									<Col md='8'>
										<label className='d-flex mt-3'>
											Add a Location
										</label>
										<input
											type='text'
											className='form-control'
											defaultValue={
												props.memoirData.location
											}
											placeholder='City'
											onChange={e =>
												handleMemoirEditField(
													'location',
													e.target.value
												)
											}
										></input>
									</Col>
								</Row>
							</div>

							<h5 className='d-flex mt-5'>
								Memoir Privacy Settings
							</h5>
							<div className='d-flex'>
								<p className='mt-0'>
									Your privacy is extremely important to us.
									You can
									<br />
									change these settings at anytime
								</p>
							</div>
							<div className='settings'>
								<div className='d-flex align-items-center'>
									<span>
										<CustomToggler
											value={
												props.memoirData.isMemoirPublic
											}
											isDisabled={false}
											onChange={async e => {
												handleMemoirEditField(
													'isMemoirPublic',
													e.target.value
												);
												if (e.target.value == true) {
													console.log('Inside');
													await handleMemoirEditField(
														'isIntroductionVisible',
														false
													);
												}
											}}
										/>
									</span>
									<p className='font-weight-bold ml-4'>
										Memoir is public
									</p>
								</div>
								<div className='d-flex align-items-center'>
									<span>
										<CustomToggler
											value={
												props.memoirData
													.isHomeTownPublic
											}
											isDisabled={false}
											onChange={e =>
												handleMemoirEditField(
													'isHomeTownPublic',
													e.target.value
												)
											}
										/>
									</span>
									<p className='font-weight-bold ml-4'>
										Hometown is public
									</p>
								</div>
								<div className='d-flex align-items-center'>
									<span>
										<CustomToggler
											value={props.memoirData.isDOBPublic}
											onChange={e =>
												handleMemoirEditField(
													'isDOBPublic',
													e.target.value
												)
											}
											isDisabled={false}
										/>
									</span>
									<p className='font-weight-bold ml-4'>
										DOB is public
									</p>
								</div>

								<div className='d-flex align-items-center'>
									<span>
										<CustomToggler
											onChange={e =>
												handleMemoirEditField(
													'isIntroductionVisible',
													e.target.value
												)
											}
											value={
												props.memoirData
													.isIntroductionVisible
											}
											isDisabled={
												props.memoirData.isMemoirPublic
											}
										/>
									</span>
									<p className='font-weight-bold ml-4'>
										Allow memoir introduction to be visible
									</p>
								</div>
							</div>
							<div className='d-flex mt-3 justify-content-center'>
								<button
									className='btn btn-outline w-100 mr-2'
									style={{
										border: '1.5px solid #566edc',
										color: '#566edc',
									}}
									disabled={loading}
								>
									{loading ? (
										<Spinner size='sm' />
									) : (
										'Update a memoir'
									)}
								</button>
								<button
									className='btn btn-outline w-100'
									onClick={e => {
										e.preventDefault();
										props.toggleModalEdit('createTimeline');
									}}
								>
									Cancel
								</button>
							</div>
						</div>
					</Form>
				</ModalBody>
			</Modal>
		</>
	);
}

export default EditMemora;
